import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Designation = apiContainer.Designation
//GET--->
// Corrected getDesignation function
export async function getDesignationApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Designation}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createDesignation(request) {
    try {
        return api.create(`${Designation}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateDesignation(request, DesignationId) {
    try {
        return api.update(`${Designation}/${DesignationId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteDesignation(DesignationId) {
    try {
        return api.delete(`${Designation}/${DesignationId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}



